import { GlobalDataContext } from "./context";
import { useAgentPermissionsManager } from "./hooks/agentPermissionsManager";
import { useAgentQueuesManager } from "./hooks/agentQueuesManager";
import { useAppSettingsManager } from "./hooks/appSettingsManager";
import { useCallSessionManager } from "./hooks/callSessionManager";
import { useMessagingInviteSessionManager } from "./hooks/messagingSessionManager";
import { useNavigationTabsManager } from "./hooks/navigationStoreManager";
import { useWrapUpManager } from "./hooks/wrapUpManager";
import { useSupervisorManager } from "./hooks/supervisorManager";
import { useSupervisorQueuesManager } from "./hooks/supervisorQueuesManager";
import { useVoicemailSessionManager } from "./hooks/voicemailSessionManager";
import { useInteractionFilterManager } from "./hooks/interactionFilterManager";
import { useResourcesManager } from "./hooks/resourcesManager";
import { useResourcesOpener } from "./hooks/resourcesOpener";
import { useSupervisorAgentsFilterManager } from "./hooks/supervisorAgentsFilterManager";
import { useMessagingTransferManager } from "./hooks/messagingTransferManager";
import { useAccountManager } from "./hooks/accountManager";
import { usePresenceManager } from "./hooks/presenceManager";
import { useAicLockManager } from "./hooks/aicLockManager";
import { useWebchatCallRequestManager } from "./hooks/webchatCallRequestManager";

export const GlobalDataProvider = (props: { children: any }) => {
	useAppSettingsManager();
	useAgentQueuesManager();
	useCallSessionManager();
	useMessagingInviteSessionManager();
	useNavigationTabsManager();
	useWrapUpManager();
	useSupervisorManager();
	useSupervisorQueuesManager();
	useAgentPermissionsManager();
	useVoicemailSessionManager();
	useInteractionFilterManager();
	useResourcesManager();
	useResourcesOpener();
	useMessagingTransferManager();
	useSupervisorAgentsFilterManager();
	useAccountManager();
	usePresenceManager();
	useAicLockManager();
	useWebchatCallRequestManager();

	return (
		<GlobalDataContext.Provider value={{}}>
			{props.children}
		</GlobalDataContext.Provider>
	);
};
